export default function CartProduct(props){

    function removeItem(){
        props.setCart(prev => {
            return prev.filter(product => product.category !== props.category);
        });
    }

    return (
        <div className="cart-wrapper">
            <div className="cart-product-container">
                <div className="cart-product">
                    <h4>{props.category}</h4>
                    <div className="product-description">
                        <div className="product-quantity">{props.quantity}x</div>
                        <div className="product-price">@ {props.price}</div>
                        <div className="product-total">${props.total}</div>
                    </div>
                </div>
                <img className="remove-product" onClick={removeItem} src="./images/icon-remove-item.svg" alt="remove item" />
            </div>
            <hr />
        </div>
    )
}